import type { CountryConfig } from '../types';

export const NIGERIA_CONFIG: CountryConfig = {
    currencyCode: 'NGN',
    currencySuffix: 'NGN',
    phoneCountryCode: '+234',
    phoneCountryLabel: 'Nigeria (+234)',
    whatsappSupportNumber: '+234 8XX XXXXXXX', // placeholder — replace with real Nigeria support line before launch
    septaBankName: 'PLACEHOLDER NIGERIA BANK NAME',
    septaAccountName: 'PLACEHOLDER NIGERIA ACCOUNT NAME',
    septaAccountNumber: 'PLACEHOLDER-NGN-0000',
    usesCombinedRanking: true,
    ordersClassesByTier: true,
    excludesSelectiveSubjects: true,
    usesTermUploadReports: true,
    usesElementBasedReports: true,
    usesCustomAssessmentTypes: true,
    usesSelectiveStudentPicker: true,
    usesBranchGroupTargeting: true,
    usesAssessmentComponents: true,
    usesLocalizedCurrencyFormat: true,
    usesNigerianClassDefaults: true,
    usesCustomTimetableEntries: true,
    usesExamEventTermDates: true,
    usesActiveRosterInRankings: true,
    usesAttendanceBackfill: true,
    usesAssessmentTerminology: true,
    usesStaffRolesSearch: true,
    usesDeferredBaseFee: true,
};
